import {setupI18n} from '@lingui/core';
import {useLingui} from '@lingui/react';
import {en, it, es} from 'make-plural/plurals';
import config from 'config';

export const locales = {
  en: 'English',
  it: 'Italian',
  es: 'Español',
};

export const defaultLocale = 'en';

export function loadCatalog(locale) {
  let lang = getLanguageCode(locale);

  if (!Object.keys(locales).includes(lang)) {
    lang = defaultLocale;
  }

  return import(
    /* webpackMode: "lazy", webpackChunkName: "i18n-[index]" */
    `locales/${lang}/messages.js`
  )
    .then(catalog => i18n.load(lang, catalog.messages))
    .then(_ =>
      i18n.loadLocaleData({[lang]: {plurals: lang === 'it' ? it : lang === 'es' ? es : en}})
    )
    .then(_ => i18n.activate(lang));
}

export const i18n = config.appEnv === 'dev' ? setupI18n({missing: '🚨'}) : setupI18n();

export const getLanguageCode = locale => {
  const [code, region] = locale.split(/[-_]+/);

  return code.toLowerCase();
};

export function I18nRenderProp({children}) {
  const {i18n} = useLingui();
  return children({i18n});
}
